export const  PrimaryButton = "rgb(30,173,219)"
export const  PrimaryButtonHover = "rgb(30,173,219)" 
export const ButtonText = "#ffffff"
export const PrimaryBackgroundColor = "#006e7d"